import React, { useEffect, useState, useRef } from "react";
import { isValidEmail, isValidEmailorEmpty } from "../../helpers/utilities";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { EditableInput } from "../Utility/EditableInput";
import { Modal } from "react-bootstrap";

import {
  BsPencil,
  BsPencilFill,
  BsPlus,
  BsTrash,
  BsTrashFill,
} from "react-icons/bs";

export const EmailEditModal = ({
  show,
  onHide,
  title,
  emailString,
  finishEditingUserEmails,
  setEmailsValid,
  returnNewEmailString,
  maxEmails,
  maxEmailLength,
  saveChanges,
  initialEmailString,
  ...props
}) => {
  const [emails, setEmails] = useState([]);
  //   const [originalEmails, setOriginalEmails] = useState([]);
  const [isAddingEmail, setIsAddingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [startedTypingNewEmail, setStartedTypingNewEmail] = useState(false);
  const [hasEdited, setHasEdited] = useState(false);
  const newEmailRef = useRef();
  // console.log(emailString);
  useEffect(() => {
    if (emailString === "" && !hasEdited) {
      setEmails([]);
    } else if (emailString !== "") {
      // console.log("hiya");
      setEmails(
        emailString.split(";").map((email) => {
          return email.trim();
        })
      );
    }
  }, [emailString]);

  // console.log("yo");
  // console.log(emailString);
  // console.log(emails);

  const addEmail = (e) => {
    // setEmails([...emails, ""]);
    setIsAddingEmail(true);
    // console.log(newEmailRef);
    // addEmailRef.current.focus();
  };

  useEffect(() => {
    if (isAddingEmail) {
      // console.log(newEmailRef);
      newEmailRef.current.focus();
    }
  }, [isAddingEmail]);

  const handleChangeToEmailBeingAdded = (e) => {
    setNewEmail(e.target.value);
    setStartedTypingNewEmail(true);
  };

  // const isValidEmail = (email, index) => {
  //   if (index === 0 && email === "") {
  //     return false;
  //   } else {
  //     return /^\S+@\S+\.\S+$/.test(email) || email === "";
  //   }
  // };

  // const allEmailsValid = emails.every((email, index) => {
  //   return isValidEmail(email, index);
  // });

  //every render, set whether all our emails are valid or not in the parent
  // setEmailsValid && setEmailsValid(allEmailsValid); //works but react warns "Cannot update a component (parent) while rendering a different component (this one)," so I moved to useEffect implementation.
  // useEffect(() => {
  //   // const allEmailsValid = emails.every((email, index) => {
  //   //   return isValidEmail(email, index);
  //   // });
  //   setEmailsValid && setEmailsValid(allEmailsValid);
  // }, [emailString]);

  // console.log(allEmailsValid);
  //We finish adding on blur or on keydown if the key was enter.
  const finishAddingEmail = (e) => {
    if (e.target.value === "") {
      setIsAddingEmail(false);
      setStartedTypingNewEmail(false);
    } else if (isValidEmailorEmpty(e.target.value)) {
      // console.log("do this");
      setEmails([...emails, e.target.value]);
      returnNewEmailString([...emails, e.target.value].join(";")); //was previously adding a space after the semicolon
      setIsAddingEmail(false);
      setNewEmail("");
      setStartedTypingNewEmail(false);
    }
  };
  const onAddingEmailKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (isValidEmailorEmpty(newEmail, 1)) {
        newEmailRef.current.blur();
      }
    }
  };

  const editEmail = (e, index) => {
    if (!hasEdited) {
      setHasEdited(true);
    }
    let newEmails = [...emails];
    newEmails[index] = e.target.value;
    setEmails(newEmails);
    const allEmailsValid = newEmails.every((email, index) => {
      return isValidEmailorEmpty(email, index);
    });
    setEmailsValid && setEmailsValid(allEmailsValid);
    returnNewEmailString(newEmails.join(";"));
  };
  const handleStopEditting = (e, index) => {
    // setIsAddingEmail(false);
    if (e.target.value === "" && index !== 0) {
      let newEmails = [...emails];
      newEmails.splice(index, 1);
      setEmails(newEmails);
      returnNewEmailString(newEmails.join(";"));
    }
  };

  const emailRefs = useRef({});

  const handleEditEmail = (e, index) => {
    // console.log(emailRefs);
    emailRefs.current[index].focus();
  };

  const handleDeleteEmail = (e, index) => {
    if (emails.length > 1) {
      let newEmails = [...emails];
      newEmails.splice(index, 1);
      setEmails(newEmails);
      returnNewEmailString(newEmails.join(";"));
    } else {
      // console.log("not enough emails to delete"); // but we'll get rid of the delete button instead
    }
  };

  const handleOnCancelClick = () => {
    handleCloseWithoutFinish();
  };

  const handleOnFinishClick = async () => {
    returnNewEmailString(emails.join(";"));
    emailRefs.current = {};
    await saveChanges();
    onHide();
  };

  const handleCloseWithoutFinish = () => {
    emailRefs.current = {};
    setEmails(initialEmailString.split(";").map((email) => email.trim()));
    returnNewEmailString(initialEmailString);
    // setEmails(
    //   emailString.split(";").map((email) => {
    //     return email.trim();
    //   })
    // );
    if (isAddingEmail) {
      setIsAddingEmail(false);
      setNewEmail("");
    }
    onHide();
  };

  // console.log(emailRefs);

  const allEmailsValid = emails.every((email) => {
    return isValidEmail(email);
  });

  // console.log(allEmailsValid);
  // console.log(emailRefs);
  return (
    <Modal show={show} onHide={handleCloseWithoutFinish} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul style={{ listStyle: "none", paddingLeft: 0, marginBottom: 0 }}>
          {emails.map((email, index) => {
            return (
              <li
                key={index} // if we put the email as the key, the component will be rerendered on every change and brought back to its display state. (i.e. you will be kicked out of editting on each change)
                className="list-border-bottom"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  //   borderBottom: "1px solid rgba(0,0,0,.2)",
                  marginTop: "2px",
                  //   marginBottom: "2px",
                  paddingBottom: "2px",
                }}
              >
                <div style={{ flex: "1" }}>
                  <EditableInput
                    key={index}
                    refObject={emailRefs}
                    index={index} //needed to map email refs
                    value={email}
                    className={
                      isValidEmailorEmpty(email, index) ? "" : "border-danger"
                    }
                    onChange={(e) => {
                      editEmail(e, index);
                    }}
                    onBlur={(e) => {
                      handleStopEditting(e, index);
                    }}
                    unfocusOnEnter
                    validTest={(input) => {
                      return isValidEmailorEmpty(input, index);
                    }}
                    maxLength={maxEmailLength}
                    //   resetStateNotif={resetStateNotif}
                    applyMarginBottomOnEditing={false}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn p-0 pl-2 shadow-none"
                    onClick={(e) => {
                      handleEditEmail(e, index);
                    }}
                  >
                    <BsPencilFill style={{ marginTop: "-7px" }} />
                  </button>
                  <button
                    type="button"
                    className="btn p-0 p-1 shadow-none"
                    onClick={(e) => {
                      handleDeleteEmail(e, index);
                    }}
                  >
                    <BsTrashFill style={{ marginTop: "-7px" }} />
                  </button>
                </div>
              </li>
            );
          })}
          {isAddingEmail && (
            <li
              className="list-border-bottom"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                //   borderBottom: "1px solid rgba(0,0,0,.2)",
                marginTop: "2px",
                marginBottom: "2px",
              }}
            >
              <EditableInput
                refThing={newEmailRef}
                className={
                  !startedTypingNewEmail || isValidEmailorEmpty(newEmail)
                    ? ""
                    : "border-danger"
                }
                value={newEmail}
                onBlur={finishAddingEmail}
                onKeyDown={onAddingEmailKeyDown}
                onChange={handleChangeToEmailBeingAdded}
                validTest={isValidEmailorEmpty}
                maxLength={maxEmailLength}
              />
            </li>
          )}
          {/* <button
            type="button"
            className="btn"
            style={{
              border: "2px solid gray",
              float: "right",
              padding: "5px",
              marginTop: "1rem",
            }}
          >
            <BsPlus
              size={16}
              style={{ marginTop: "-3px", marginRight: "-2px" }}
            />{" "}
            New Email
          </button> */}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleOnCancelClick}
        >
          Cancel
        </button>
        {!isAddingEmail && emails.length < maxEmails && (
          <button type="button" className="btn btn-primary" onClick={addEmail}>
            New Email
          </button>
        )}
        <button
          type="button"
          className="btn btn-success"
          onClick={handleOnFinishClick}
          disabled={!allEmailsValid || isAddingEmail}
        >
          Finish
        </button>
      </Modal.Footer>
    </Modal>
  );
};
